import { ComboField } from '~/components/form';
import { FilterDrawer } from '~/components/ui';

/** The applied filters by URL key: `status` (`active`, `draft`, or empty for both) and `component`. */
type PlacementFilters = Record<string, string>;

interface PlacementFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  value: PlacementFilters;
  componentOptions: string[];
  onApply: (next: PlacementFilters) => void;
  onClear: () => void;
}

const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'active', label: 'Active' },
  { value: 'draft', label: 'Draft' },
];

/** The placements list's filter tray: status and component, applied together. */
export default function PlacementFilterDrawer({
  open,
  onClose,
  value,
  componentOptions,
  onApply,
  onClear,
}: PlacementFilterDrawerProps) {
  return (
    <FilterDrawer<PlacementFilters>
      open={open}
      onClose={onClose}
      value={value}
      onApply={onApply}
      onClear={onClear}
      testId="ai-placements-filter-drawer"
    >
      {(draft, patch) => (
        <>
          <ComboField
            id="ai-placements-filter-status"
            testId="ai-placements-filter-status-select"
            label="Status"
            value={draft.status}
            options={STATUS_OPTIONS}
            searchable={false}
            onChange={(status) => patch({ status })}
          />
          <ComboField
            id="ai-placements-filter-component"
            testId="ai-placements-filter-component-select"
            label="Component"
            value={draft.component}
            options={[
              { value: '', label: 'All components' },
              ...componentOptions.map((id) => ({ value: id, label: id })),
            ]}
            searchable
            onChange={(component) => patch({ component })}
          />
        </>
      )}
    </FilterDrawer>
  );
}
